import { select, take, fork } from 'redux-saga/effects';
import { VideoDisconnectedAction, VideoPauseAction } from 'actions/monitoringActions';
import { getCell } from 'selectors/monitoringSelectors';
import { CellState, CellIndex } from 'types';
import { seekSaga } from './seekSaga';

//
// Pause Workflow
//
//  1. User clicks the pause button in PlaybackControls
//  2. PlaybackControls dispatches VIDEO_PAUSE action
//  3. monitoringReducer sets playing to false for the specified cell
//  4. pauseWatcher wakes up and forks the disconnectWatcher for the same cell
//  5. React gets change notification and does a redraw
//  6. Fade component starts fading out the VideoView component
//  7. VideoView receives visible=false in componentDidUpdate
//  8. VideoView dispatches VIDEO_DISCONNECTED action (which indicates the stream position)
//  9. monitoringReducer stores the stream position for the cell
// 10. disconnectWatcher wakes up, initiates a seek request for the current stream position, and exits
//
// Note: other things seek directly without VIDEO_PAUSE (e.g. clicking on the timeline, clicking an alarm, etc.)
//       That's why this workflow waits for VIDEO_PAUSE first and then waits for a VIDEO_DISCONNECT in the same cell.
//       (otherwise, the cell would end up seeking twice).

export function* pauseWatcher() {
    while (true) {
        const action: VideoPauseAction = yield take('VIDEO_PAUSE');
        const cellIndex = action.payload;
        yield fork(disconnectWatcher, cellIndex);
    }
}

export function* disconnectWatcher(cellIndex: CellIndex) {
    const action: VideoDisconnectedAction =
        yield take(({ type, payload }: VideoDisconnectedAction) =>
            type === 'VIDEO_DISCONNECTED' &&
            payload.cellIndex === cellIndex
        );
    const { utcTime } = action.payload;
    const { streamId }: CellState = yield select(getCell, { cellIndex });
    if (!streamId) {
        // Ignore if cell does not have a stream assigned
        return;
    }
    yield fork(seekSaga, cellIndex, streamId, 'to', utcTime);
}



// WEBPACK FOOTER //
// ./src/sagas/monitoring/pauseSaga.ts